import React, { Component, Fragment } from 'react';
// import { Link } from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {authorFollowAction} from '../../../actions/index';
import { translate } from 'react-i18next';
import cx from '../../../styles';

class AuthorFollowButton extends Component {

    constructor(props) {
        super(props);
        this.state = {isFollowed: false};
    }

    componentDidMount() {
        this.setState({isFollowed: this.props.author.following});
    }

    authorFollowHandler = () => {
        this.props.authorFollowAction(this.props.author.id, 1)
        .then(()=>{
            if(this.props.userReducer.id) this.setState({isFollowed: true});
        });
    }

    authorUnfollowHandler = () => {
        this.props.authorFollowAction(this.props.author.id, 0)
        .then(()=>{
            if(this.props.userReducer.id) this.setState({isFollowed: false});
        });
    }

    render() {
        const {t} = this.props;

        return (
            <Fragment>
                {
                    !this.state.isFollowed
                    ?
                    <Fragment>
                        <button className={cx("btn", "btn-primary")} onClick={this.authorFollowHandler}>{t('profile_follow')}</button>
                        {/*<button className={cx("btn-plus", "only-mobile")} onClick={this.authorFollowHandler}></button>*/}
                    </Fragment>
                    :
                    <Fragment>
                        <button className={cx("btn", "btn-border")} onClick={this.authorUnfollowHandler}>{t('profile_unfollow')}</button>
                        {/*<button className={cx("btn-minus", "only-mobile")} onClick={this.authorUnfollowHandler}></button>*/}
                    </Fragment>
                }
            </Fragment>
        );
    }


}

//map state
const mapStateToProps = (state) => {
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        authorFollowAction
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(AuthorFollowButton));
